export class GelMessage {
  message: string;
  date: string | Date;
  reply: boolean;
  type: string;
  user: { name: string };
  isRead: boolean;
}
